import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Card,
  CardContent,
  Typography,
} from '@mui/material';

const styles = {
  iconWrapper: {
    margin: '14px 0 12px 0',
    '& *': {
      margin: '0 6px',
    },
  },
  secondaryCard: {
    marginBottom: '14px',
    textAlign: 'center',
  },
}

export default function GuideCard({ body, icons }) {

  return (
    <Card sx={styles.secondaryCard}>
      <CardContent>
        <Box sx={styles.iconWrapper}>{icons}</Box>
        <Typography>{body}</Typography>
      </CardContent>
    </Card>
  );
}

GuideCard.propTypes = {
  body: PropTypes.node,
  icons: PropTypes.node,
};
